import { CHANGE_MOBILE_NUMBER_10_REGEX, CHANGE_MOBILE_NUMBER_11_REGEX } from 'utils/regex';

export const changeMobileForm = (mobile: string) => {
    return mobile.length === 11 ? mobile.replace(CHANGE_MOBILE_NUMBER_11_REGEX, '$1-$2-$3') : mobile.replace(CHANGE_MOBILE_NUMBER_10_REGEX, '$1-$2-$3');
};
